export default __webpack_public_path__ + "static/img/bubble-1@2x.eb9781.png";